export default {"src":"/_next/static/media/check.c22e3cfb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};